/**
 * JKL PDP Gallery
 * Product image gallery with Swiper carousel.
 * Supports images and HLS video.
 * Layout: main carousel on top, optional thumbnails strip below (synced via Thumbs module).
 */

import Swiper from './swiper-bundle.esm.browser.min.js';

(function () {
  function initGallery() {
    const galleries = document.querySelectorAll('[data-gallery]');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      const swiperEl = gallery.querySelector('[data-swiper]');
      if (!swiperEl) return;
      if (swiperEl.swiper) return;

      const showPagination = gallery.dataset.showPagination !== 'false';
      const showThumbs = gallery.dataset.showThumbnails === 'true';

      let thumbsSwiper = null;

      if (showThumbs) {
        const thumbsEl = gallery.querySelector('[data-thumbs]');
        if (thumbsEl && !thumbsEl.swiper) {
          thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            freeMode: true,
          });
        }
      }

      const swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        autoHeight: false,
      };

      if (showPagination) {
        swiperOptions.pagination = {
          el: gallery.querySelector('.jkl-pdp-gallery__pagination'),
          clickable: true,
          bulletClass: 'jkl-pdp-gallery__bullet',
          bulletActiveClass: 'jkl-pdp-gallery__bullet--active',
        };
      }

      if (thumbsSwiper) {
        swiperOptions.thumbs = { swiper: thumbsSwiper };
      }

      new Swiper(swiperEl, swiperOptions);

      initVideos(gallery);
    });
  }

  function initVideos(gallery) {
    const videos = gallery.querySelectorAll('video[data-src]');

    videos.forEach(function (video) {
      const src = video.dataset.src;
      if (!src) return;

      if (src.includes('/hls/') || src.includes('.m3u8')) {
        if (typeof Hls !== 'undefined' && Hls.isSupported()) {
          const hls = new Hls({ enableWorker: false });
          hls.loadSource(src);
          hls.attachMedia(video);
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = src;
        } else {
          video.src = src;
        }
      } else {
        video.src = src;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();
